export const LOCAL_SPACE_X = 1000
export const LOCAL_SPACE_Y = 1000
